import { DnldPolicyComponent, H4Tag } from "@tm/static";
import { PageContainer, PageGreyWrap } from "./OrderDetail.style";
import { DownloadPageProps } from "./types";

const DownloadPolicy = ({ data }: DownloadPageProps) => {
  const { screen, travellersInsured } = data;
  return (
    <PageContainer id={"pageId"}>
      <PageGreyWrap>
        <H4Tag>{screen.title}</H4Tag>
        <DnldPolicyComponent
          data={screen.list}
          travellersInsured={travellersInsured}
        />
      </PageGreyWrap>
    </PageContainer>
  );
};

export default DownloadPolicy;
